import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getOwnLocale } from '../api/locale.ts';
import { applyLocale } from './index.ts';

/** Shared with `LanguageMenu.tsx`, so a write there and the read here stay one cache entry. */
export const LOCALE_QUERY_KEY = ['profile', 'locale'] as const;

/**
 * Keeps `i18next`'s active language following the caller's own stored preference.
 *
 * Called once, from `AppShell` — the one component only ever rendered once a session exists, so
 * `GET /api/profile/locale` is reachable. Before that (the login page), `i18n/index.ts`'s own
 * module-load `init()` already applied the browser-only half of the fallback chain; this layers the
 * account preference on top the moment it is known, and again on every later change (an admin
 * signing out and a different person signing in on the same browser, an org switch, or the
 * preference itself changing elsewhere).
 */
export function useSyncAccountLocale(): void {
  const query = useQuery({
    queryKey: LOCALE_QUERY_KEY,
    queryFn: ({ signal }) => getOwnLocale(signal),
  });

  useEffect(() => {
    if (query.data !== undefined) applyLocale(query.data.locale);
  }, [query.data]);
}
